<template>
  <div :class="['ms-form', 'ms-form--narrow', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomSelect :options="agreementOptions" label="Договор" :required="true" optionValueKey="contractor_agreement_list_id"
          optionLabelKey="agreement_name" :fullWidth="true" :value="this.formData.contractor_agreement_list_id"
          @change="(value) => onChange('contractor_agreement_list_id', value)" />
      </div>

      <CustomModalFooter :btn-loading="this.btnLoading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import { getAgreementsList } from "@/views/MaterialProviderList/services";

export default {
  name: "material-list-attach-agreement",
  components: { CustomModalFooter, CustomSelect },
  props: ['data'],
  data() {
    return {
      loading: false,
      btnLoading: false,
      formData: {
        material_provider_id_arr: this.data?.body.material_provider_id_arr || '',
        contractor_agreement_list_id: '',
      },
      agreementOptions: [],
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.btnLoading = true
      await this.data?.onSubmit(this.formData)
      this.btnLoading = false
    },
    async fetchAgreements() {
      this.agreementOptions = await getAgreementsList(this.data?.body.provider_id);
    },
  },
  mounted() {
    this.fetchAgreements();
  }
}
</script>